<template>
  <div>
   <OverpaymentsNRefundsList/>
  </div>
</template>

<script>
import OverpaymentsNRefundsList from '../../../../components/tax/payments/utils/OverpaymentsNRefunds/OverpaymentsNRefundsList.vue';

export default {
  name: 'OverpaymentsNRefundsView',
  components: {
    OverpaymentsNRefundsList,
  },
};
</script>
